import { apiClient } from "@/core/api/httpClient";
import billingApi from "@/modules/billing/services/api";

export default {
  getBillingInfos: async () => {
    return await apiClient.get(`billing-info`).then(json=> json.data);
  },
  getPriceLevelGroups:async() => {
    return await billingApi.getItems().then((response) => response.data);
  },
};
